"use client"

interface RangeSliderProps {
  min: number
  max: number
  step: number
  value: [number, number]
  onChange: (value: [number, number]) => void
  onCommit?: (value: [number, number]) => void
  lowLabel: string
  highLabel: string
  formatValue?: (value: number) => string
  className?: string
}

export const RangeSlider = ({ min, max, step, value, onChange, onCommit, lowLabel, highLabel, formatValue = String, className }: RangeSliderProps) => {
  const [low, high] = value
  const span = max - min || 1
  const percent = (amount: number) => ((amount - min) / span) * 100
  const commit = () => onCommit?.(value)
  return (
    <div className={`relative h-5 ${className ?? ""}`}>
      <div className="bg-line-subtle absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 rounded-full" aria-hidden />
      <div className="bg-brand absolute top-1/2 h-1 -translate-y-1/2 rounded-full" style={{ left: `${percent(low)}%`, right: `${100 - percent(high)}%` }} aria-hidden />
      <input
        type="range"
        className="range-input"
        min={min}
        max={max}
        step={step}
        value={low}
        aria-label={lowLabel}
        aria-valuetext={formatValue(low)}
        style={{ zIndex: low >= max - step ? 2 : 1 }}
        onChange={(event) => onChange([Math.min(Number(event.target.value), high), high])}
        onPointerUp={commit}
        onKeyUp={commit}
      />
      <input
        type="range"
        className="range-input"
        min={min}
        max={max}
        step={step}
        value={high}
        aria-label={highLabel}
        aria-valuetext={formatValue(high)}
        onChange={(event) => onChange([low, Math.max(Number(event.target.value), low)])}
        onPointerUp={commit}
        onKeyUp={commit}
      />
    </div>
  )
}
